import { stringifyColor } from './color';
import { useCurrentBackground } from './useCurrentBackground';
export var useHasColoredBackground = function () {
    var backgroundColor = useCurrentBackground();
    return stringifyColor(backgroundColor) !== '#FFFFFF';
};
//# sourceMappingURL=useHasColoredBackground.js.map